import { Routes } from '@angular/router';
import { LandingComponent } from './landing/landing';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'alianza-yango'
  },
  {
    path: 'alianza-yango',
    component: LandingComponent
  },
  {
    path: '**',
    redirectTo: 'alianza-yango'
  }
];
